import React from 'react';

import {
  PluginBox,
  PluginBoxHeader,
  PluginBoxDescription,
  PluginBoxVersion,
} from '../../styles';
import { PlaceholderIcon, PlaceholderText } from './styles';

const PlaceholderPlugin = () => (
  <PluginBox>
    <PluginBoxHeader>
      <PlaceholderIcon />
      <PlaceholderText height={15} width={70} />
    </PluginBoxHeader>
    <PluginBoxDescription>
      <PlaceholderText height={12} width={200} />
      <PlaceholderText height={12} width={200} />
    </PluginBoxDescription>
    <PluginBoxVersion>
      <PlaceholderText height={10} width={30} />
    </PluginBoxVersion>
  </PluginBox>
);

export default PlaceholderPlugin;
